(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["tdp-tenant-context-provider"] = factory();
	else
		root["tdp-tenant-context-provider"] = factory();
})(self, () => {
return 